import { render } from "./ListarDocumentos.vue?vue&type=template&id=4355f17c&scoped=true"
import script from "./ListarDocumentos.vue?vue&type=script&lang=js"
export * from "./ListarDocumentos.vue?vue&type=script&lang=js"

import "./ListarDocumentos.vue?vue&type=style&index=0&id=4355f17c&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4355f17c"]])

export default __exports__